/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { conjDependencies } from './dependenciesConj.generated.js';
import { dotDivideDependencies } from './dependenciesDotDivide.generated.js';
import { fftDependencies } from './dependenciesFft.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIfft } from '../../factoriesAny.js';
export var ifftDependencies = {
  conjDependencies,
  dotDivideDependencies,
  fftDependencies,
  typedDependencies,
  createIfft
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIfft.generated.js
// module id = 1380
// module chunks = 2